import type { SVGProps } from "react";
import * as React from "react";

const SvgCheckSquare = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M9.707 10.293a1 1 0 1 0-1.414 1.414zM12 14l-.707.707a1 1 0 0 0 1.414 0zm10.707-9.293a1 1 0 0 0-1.414-1.414zM22 12a1 1 0 1 0-2 0zM3 19H2zM5 3V2zm11 1a1 1 0 1 0 0-2zm-7.707 7.707 3 3 1.414-1.414-3-3zm4.414 3 10-10-1.414-1.414-10 10zM20 12v7h2v-7zm0 7a1 1 0 0 1-.293.707l1.414 1.414A3 3 0 0 0 22 19zm-.293.707A1 1 0 0 1 19 20v2a3 3 0 0 0 2.121-.879zM19 20H5v2h14zM5 20a1 1 0 0 1-.707-.293l-1.414 1.414A3 3 0 0 0 5 22zm-.707-.293A1 1 0 0 1 4 19H2a3 3 0 0 0 .879 2.121zM4 19V5H2v14zM4 5a1 1 0 0 1 .293-.707L2.879 2.879A3 3 0 0 0 2 5zm.293-.707A1 1 0 0 1 5 4V2a3 3 0 0 0-2.121.879zM5 4h11V2H5z"
    />
  </svg>
);
export default SvgCheckSquare;
